import React, { ComponentProps } from 'react';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { FooterLink } from '../../components/molecules/FooterLink/FooterLink';
import { TeamRoomMemberRequestsListItem } from './partials/TeamRoomMemberRequestsListItem';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import IUrl from '../../types/IUrl';

type TeamRoomMemberRequestsListProps = {
  members?: TeamRoomMemberRequestsListItem[];
  linkToMembersPage?: IUrl;
};

/**
 * MemberRequestList shows all MemberRequests
 */
function TeamRoomMemberRequestsList({ members, linkToMembersPage }: TeamRoomMemberRequestsListProps) {
  const { t } = useSonTranslation('TeamRoomMemberRequests');

  return (
    <>
      {members && members.length > 0
        ? (
            <ContentList>
              {members?.map(member => (
                <ContentListItem key={member.profileLink.name}>
                  <TeamRoomMemberRequestsListItem {...member} />
                </ContentListItem>
              ))}
            </ContentList>
          )
        : (
            <ContentMessage text={t('empty')} />
          )}
      {linkToMembersPage && <FooterLink footerButtonLabel={t('goToMemberManagement')} footerLink={linkToMembersPage} />}
    </>
  );
}

export const TeamRoomMemberRequestsListBlock = asFetchableBlock(
  TeamRoomMemberRequestsList,
  BlockType.teamroommemberrequestslist,
);
export type TeamRoomMemberRequestsListBlock = ComponentProps<typeof TeamRoomMemberRequestsListBlock>;
